/* BagSafe booking card + live timeline (window.BSBook).
   Shared by My bookings, the tracking page and the ops console.
   Renders the public booking view returned by the backend's /track and /account. */
(function () {
  if (window.BSBook) return;

  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var ICON = {
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2Z"/></svg>',
    store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="7" width="14" height="13" rx="2"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M9 12h6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2Z"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3a.5.5 0 0 0 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .1-1.3c0-.1-.2-.2-.4-.3Z"/></svg>',
    out: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12L12 4M6 4h6v6"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7"/><path d="m16 6-4-4-4 4"/><path d="M12 2v13"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Every time is shown in Kolkata time, wherever the customer is. */
  function fmt(iso, withDay) {
    if (!iso) return '';
    var d = new Date(new Date(iso).getTime() + 330 * 60000);
    if (isNaN(d.getTime())) return '';
    var h = d.getUTCHours(), m = d.getUTCMinutes();
    var t = ((h % 12) || 12) + ':' + (m < 10 ? '0' : '') + m + ' ' + (h < 12 ? 'AM' : 'PM');
    return (withDay === false ? '' : DOW[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()] + ', ') + t;
  }
  function fmtDay(iso) {
    if (!iso) return '';
    var d = new Date(new Date(iso).getTime() + 330 * 60000);
    return isNaN(d.getTime()) ? '' : DOW[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()];
  }
  function initials(name) {
    return String(name || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0).toUpperCase(); }).join('');
  }
  function digits(p) { return String(p || '').replace(/\D/g, ''); }
  /* Addresses from the storage flow can carry a map URL; show the words only. */
  function place(p) { return String(p || '').split(' · ').filter(function (x) { return !/^https?:\/\//.test(x); }).join(' · '); }

  function api(base, path, body, token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = 'Bearer ' + token;
    var url = base.replace(/\/+$/, '') + path;
    /* Run the backend next to its database (Tokyo). Left to itself the function runs near
       the visitor and every query crosses to Tokyo: about 4x slower from India. */
    if (/\.supabase\.co\//.test(url)) url += (url.indexOf('?') < 0 ? '?' : '&') + 'forceFunctionRegion=ap-northeast-1';
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body || {}) })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok) {
            var err = new Error(j.message || 'Something went wrong. Please try again.');
            err.code = j.error; err.status = res.status; err.data = j;
            throw err;
          }
          return j;
        });
      });
  }

  var HEADLINE = {
    booked: 'Booking confirmed',
    agent_assigned: 'Your agent is assigned',
    picked_up: 'Bags picked up',
    in_transit: 'Your bags are on the way',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
    stored: 'Stored safely at our hub',
    out_for_drop: 'On the way back to you',
    returned: 'Bags returned',
    cancelled: 'Booking cancelled'
  };
  function lede(b) {
    var d = b.details || {};
    if (b.courier_problem && !b.done && !b.cancelled) {
      var hit = (b.shipments || []).filter(function (x) { return x.problem; })[0];
      if (hit) return hit.problem.body;
    }
    switch (b.status) {
      case 'booked':
        return b.service === 'store'
          ? 'Agent pickup ' + fmt(b.pickup_at) + '. We’ll message you when your agent is assigned.'
          : (d['Pickup Type'] === 'scheduled' && b.pickup_at ? 'Agent pickup ' + fmt(b.pickup_at) + '. ' : '') + 'We’ll message you when your agent is assigned.';
      case 'agent_assigned': return (b.agent ? b.agent.name : 'Your agent') + ' will call before arriving' + (b.pickup_at ? ' for the ' + fmt(b.pickup_at) + ' pickup.' : '.');
      case 'picked_up': return 'Sealed and tagged. See the photos your agent took below.';
      case 'in_transit': {
        var c = courierOf(b);
        return (c ? 'With ' + c + ', on the way to ' : 'Travelling to ') + dest(b) + '.' + (b.eta ? ' Expected by ' + fmtDay(b.eta) + '.' : '');
      }
      case 'out_for_delivery': return 'Arriving today' + (courierOf(b) ? ' with ' + courierOf(b) : '') + '. Keep your phone handy.';
      case 'delivered': return 'Thank you for travelling light with BagSafe.';
      case 'stored': return b.drop_at ? 'Coming back to you ' + fmt(b.drop_at) + '.' : 'Sealed, tagged and stored.';
      case 'out_for_drop': return (b.agent ? b.agent.name : 'Your agent') + ' is bringing your bags back.';
      case 'returned': return 'Thank you for storing with BagSafe.';
      case 'cancelled': return 'Our team will contact you about any refund due.';
    }
    return '';
  }

  function dest(b) {
    var d = b.details || {};
    if (d['Delivery city']) return d['Delivery city'];
    var to = d['Flight To'] || '';
    return to.indexOf('—') > -1 ? to.split('—').pop().trim() : (to || 'your destination');
  }
  function courierOf(b) {
    var s = (b.shipments || []).filter(function (x) { return x.phase !== 'cancelled'; })[0];
    return s && s.courier ? s.courier.replace(/\s+(surface|air|express)\b.*$/i, '') : '';
  }

  /* The courier part of a Ship booking: arrival, any problem, every scan. */
  function courierBlock(b, opts) {
    var list = (b.shipments || []).filter(function (x) { return x.phase !== 'cancelled'; });
    if (!list.length) return '';
    var many = list.length > 1;
    var html = '<div class="bsb__courier">';
    list.forEach(function (sh) {
      html += '<div class="bsb__ship">';
      html += '<div class="bsb__ship-head">' + ICON.truck + '<span><strong>' + esc(many ? 'Bag ' + sh.bag_no + ' · ' : '') + esc(sh.courier || 'Courier') + '</strong>' +
        '<span class="bsb__awb">AWB ' + esc(sh.awb) + '</span></span>' +
        '<button type="button" class="bsb__icon-btn" data-bsb-copy="' + esc(sh.awb) + '" aria-label="Copy AWB ' + esc(sh.awb) + '">' + ICON.copy + '</button>' +
        (many ? '<span class="bsb__chip">' + esc(sh.phase_label) + '</span>' : '') + '</div>';
      if (sh.problem) html += '<p class="bsb__warn">' + ICON.alert + '<span><strong>' + esc(sh.problem.title) + '.</strong> ' + esc(sh.problem.body) + '</span></p>';
      var scans = sh.scans || [];
      if (scans.length) {
        var row = function (x) {
          return '<li><span class="bsb__scan-label">' + esc(x.label) + '</span><span class="bsb__scan-meta">' + esc(fmt(x.at)) + (x.place ? ' · ' + esc(x.place) : '') + '</span></li>';
        };
        html += '<ol class="bsb__scans">' + scans.slice(0, 3).map(row).join('') + '</ol>';
        if (scans.length > 3) {
          html += '<details class="bsb__more"><summary>All ' + scans.length + ' courier updates</summary><ol class="bsb__scans">' + scans.slice(3).map(row).join('') + '</ol></details>';
        }
      } else {
        html += '<p class="bsb__scan-empty">' + (sh.pickup_at ? 'Courier pickup from our hub ' + esc(fmt(sh.pickup_at)) + '. Scans appear here as the courier updates them.' : 'Scans appear here as soon as the courier collects your bags.') + '</p>';
      }
      if (sh.pod_url && opts.full !== false) html += '<a class="bsb__pod" href="' + esc(sh.pod_url) + '" target="_blank" rel="noopener">Proof of delivery ' + ICON.out + '</a>';
      html += '</div>';
    });
    return html + '</div>';
  }

  /* Big "when" line at the top of a Ship booking that is with the courier. */
  function eta(b) {
    var live = (b.shipments || []).filter(function (x) { return x.phase !== 'cancelled'; });
    if (!live.length || b.cancelled || b.courier_problem) return '';
    if (b.status === 'delivered') {
      var at = live.map(function (x) { return x.delivered_at; }).filter(Boolean).sort().pop();
      return at ? '<p class="bsb__eta"><span>Delivered</span>' + esc(fmt(at)) + '</p>' : '';
    }
    if (b.status === 'out_for_delivery') return '<p class="bsb__eta"><span>Arriving</span>Today</p>';
    return b.eta ? '<p class="bsb__eta"><span>Arrives by</span>' + esc(fmtDay(b.eta)) + '</p>' : '';
  }

  function facts(b) {
    var d = b.details || {}, out = [];
    if (b.service === 'store') {
      if (b.pickup_at) out.push(['Agent pickup', fmt(b.pickup_at)]);
      if (b.drop_at) out.push(['Bags back', fmt(b.drop_at)]);
      if (d['Duration']) out.push(['Duration', d['Duration']]);
      if (d['Bags']) out.push(['Bags', d['Bags']]);
    } else {
      if (d['Flight To']) out.push(['Flying to', d['Flight To']]);
      if (d['Delivery address']) out.push(['Delivering to', [d['Deliver to name'], d['Delivery address'], d['Delivery city'], d['Delivery pincode']].filter(Boolean).join(', ')]);
      else if (d['Delivery city']) out.push(['Delivering to', d['Delivery city']]);
      if (d['Flight Date']) out.push(['Flight date', d['Flight Date']]);
      if (d['Total weight']) out.push(['Weight', d['Total weight']]);
      if (d['Delivery Type']) out.push(['Delivery', d['Delivery Type']]);
    }
    if (d['Pickup place']) out.push(['Pickup from', place(d['Pickup place'])]);
    if (b.service === 'store' && d['Drop place'] && d['Drop place'] !== d['Pickup place']) out.push(['Drop at', place(d['Drop place'])]);
    if (d['Luggage cover']) out.push(['Cover', d['Luggage cover']]);
    return out;
  }

  /**
   * HTML for one booking. opts:
   *   actions  extra HTML for the action row
   *   compact  hide facts (used in lists)
   *   support  support WhatsApp number (digits) for the Need help link
   */
  function render(b, opts) {
    opts = opts || {};
    var tone = b.cancelled ? 'cancelled' : b.done ? 'done' : 'live';
    var no = esc(b.order_name) + (b.ref ? ' · ' + esc(b.ref) : '');
    var html = '<article class="bsb" data-booking="' + esc(b.id) + '">' +
      '<div class="bsb__top"><span class="bsb__svc">' + (b.service === 'store' ? ICON.store + 'Luggage storage' : ICON.ship + 'Luggage shipping') + '</span>' +
      '<span class="bsb__no">' + no + '</span>' +
      '<span class="bsb__pill" data-tone="' + tone + '">' + esc(b.status_label) + '</span></div>' +
      '<h3 class="bsb__title">' + esc(HEADLINE[b.status] || b.status_label) + '</h3>' +
      '<p class="bsb__lede">' + esc(lede(b)) + '</p>' + eta(b);

    html += '<ol class="bsb__steps" aria-label="Booking progress">';
    (b.steps || []).forEach(function (s) {
      if (b.cancelled && s.state === 'skipped') return;
      /* A finished booking's last step is done, not "in progress". */
      if (b.done && !b.cancelled && s.state === 'current') s = Object.assign({}, s, { state: 'done' });
      var srState = { done: 'Done', current: 'Current step', todo: 'Up next', skipped: 'Skipped' }[s.state] || '';
      html += '<li class="bsb__step" data-state="' + esc(s.state) + '"' + (s.state === 'current' ? ' aria-current="step"' : '') + '>' +
        '<span class="bsb__dot">' + (s.state === 'done' ? ICON.check : '') + '</span><div>' +
        '<span class="bsb__label">' + esc(s.label) + '<span class="bsb-vh"> (' + srState + ')</span></span>' +
        (s.at ? '<span class="bsb__at">' + esc(fmt(s.at)) + '</span>' : '');
      if (s.key === 'in_transit' && s.state !== 'todo') html += courierBlock(b, opts);
      if (s.photos && s.photos.length) {
        html += '<div class="bsb__photos">' + s.photos.map(function (u, i) {
          return '<button type="button" class="bsb__thumb" data-bsb-photo="' + esc(u) + '" data-bsb-group="' + esc(b.id + '-' + s.key) + '" aria-label="Photo ' + (i + 1) + ' of your bags at ' + esc(s.label) + '"><img src="' + esc(u) + '" alt="" loading="lazy" decoding="async" width="76" height="76"></button>';
        }).join('') + '</div>';
      }
      html += '</div></li>';
    });
    if (b.cancelled) {
      html += '<li class="bsb__step" data-state="current" aria-current="step"><span class="bsb__dot"></span><div><span class="bsb__label">Cancelled</span></div></li>';
    }
    html += '</ol>';
    if (b.photos_expired) html += '<p class="bsb__expired">Photos from this booking have expired and been deleted.</p>';

    if (b.agent && b.agent.name) {
      var tel = digits(b.agent.phone);
      html += '<div class="bsb__agent"><span class="bsb__avatar" aria-hidden="true">' + esc(initials(b.agent.name)) + '</span>' +
        '<div class="bsb__agent-txt"><strong>' + esc(b.agent.name) + '</strong>Your BagSafe agent · ID verified</div>' +
        (tel ? '<a class="bsb__mini" href="tel:+' + esc(tel.length === 10 ? '91' + tel : tel) + '">' + ICON.phone + 'Call</a>' : '') +
        '</div>';
    }

    if (!opts.compact) {
      var f = facts(b);
      if (b.awb && !(b.shipments || []).length) f.push(['Courier AWB', b.awb]);
      if (f.length) {
        html += '<dl class="bsb__facts">' + f.map(function (p) {
          return '<div><dt>' + esc(p[0]) + '</dt><dd>' + esc(p[1]) + '</dd></div>';
        }).join('') + '</dl>';
      }
    }

    var acts = '';
    if (opts.shareUrl && !b.done) acts += '<button type="button" class="bsb__link" data-bsb-share="' + esc(opts.shareUrl) + '" data-bsb-title="' + esc('BagSafe ' + b.order_name) + '">' + ICON.share + 'Share tracking</button>';
    var trackerUrl = ((b.shipments || []).filter(function (x) { return x.tracker_url; })[0] || {}).tracker_url || (!(b.shipments || []).length && b.awb_url);
    if (trackerUrl) acts += '<a class="bsb__link bsb__link--quiet" href="' + esc(trackerUrl) + '" target="_blank" rel="noopener">Courier’s page ' + ICON.out + '</a>';
    if (opts.support && !b.done) {
      acts += '<a class="bsb__link" href="https://wa.me/' + esc(digits(opts.support)) + '?text=' + encodeURIComponent('Hi BagSafe, I need help with booking ' + b.order_name) + '" target="_blank" rel="noopener">' + ICON.wa + 'Need help?</a>';
    }
    acts += opts.actions || '';
    html += '<div class="bsb__actions">' + acts + '</div></article>';
    return html;
  }

  /**
   * Tracking by AWB alone (anyone can type an AWB): courier progress and
   * city-level places only. opts.verify: HTML for the "is this yours?" prompt.
   */
  function renderCourier(v, opts) {
    opts = opts || {};
    var sh = v.shipment || {};
    var tone = sh.phase === 'delivered' ? 'done' : sh.phase === 'cancelled' ? 'cancelled' : 'live';
    var title = sh.problem && sh.phase !== 'delivered' ? sh.problem.title : sh.phase === 'delivered' ? 'Delivered' : sh.phase === 'ofd' ? 'Out for delivery' : sh.phase === 'cancelled' ? 'Shipment cancelled' : sh.phase === 'booked' ? 'Waiting for courier pickup' : 'On the way';
    var when = sh.phase === 'delivered' && sh.delivered_at ? '<p class="bsb__eta"><span>Delivered</span>' + esc(fmt(sh.delivered_at)) + '</p>'
      : sh.problem ? ''
      : sh.phase === 'ofd' ? '<p class="bsb__eta"><span>Arriving</span>Today</p>'
      : sh.etd && sh.phase !== 'cancelled' ? '<p class="bsb__eta"><span>Arrives by</span>' + esc(fmtDay(sh.etd)) + '</p>' : '';
    var b = { shipments: [Object.assign({}, sh, { bag_no: 1 })], details: {} };
    var html = '<article class="bsb bsb--courier">' +
      '<div class="bsb__top"><span class="bsb__svc">' + ICON.truck + 'Courier tracking</span><span class="bsb__no">AWB ' + esc(sh.awb) + '</span>' +
      '<span class="bsb__pill" data-tone="' + tone + '">' + esc(sh.phase_label || '') + '</span></div>' +
      '<h3 class="bsb__title">' + esc(title) + '</h3>' +
      '<p class="bsb__lede">' + esc((sh.courier ? 'With ' + sh.courier : 'With the courier') + (v.destination ? ', heading to ' + v.destination : '') + '.') + '</p>' + when +
      courierBlock(b, { full: false });
    if (opts.verify) html += '<div class="bsb__verify">' + opts.verify + '</div>';
    var acts = '';
    if (sh.tracker_url) acts += '<a class="bsb__link bsb__link--quiet" href="' + esc(sh.tracker_url) + '" target="_blank" rel="noopener">Courier’s page ' + ICON.out + '</a>';
    acts += opts.actions || '';
    return html + '<div class="bsb__actions">' + acts + '</div></article>';
  }

  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    var ta = document.createElement('textarea');
    ta.value = t; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    return Promise.resolve();
  }
  function flash(btn, text) {
    var old = btn.getAttribute('data-bsb-old') || btn.innerHTML;
    btn.setAttribute('data-bsb-old', old);
    btn.innerHTML = ICON.check + '<span>' + esc(text) + '</span>';
    btn.classList.add('is-done');
    setTimeout(function () { btn.innerHTML = old; btn.classList.remove('is-done'); }, 1800);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-bsb-copy]');
    if (c) { copyText(c.getAttribute('data-bsb-copy')).then(function () { flash(c, 'Copied'); }); return; }
    var sh = e.target.closest && e.target.closest('[data-bsb-share]');
    if (sh) {
      var url = sh.getAttribute('data-bsb-share');
      if (navigator.share) navigator.share({ title: sh.getAttribute('data-bsb-title') || 'BagSafe', url: url }).catch(function () {});
      else copyText(url).then(function () { flash(sh, 'Link copied'); });
    }
  });

  function skeleton() {
    return '<article class="bsb bsb--loading" aria-busy="true"><span class="bsb__sk"></span><span class="bsb__sk"></span><span class="bsb__sk"></span><span class="bsb__sk"></span></article>';
  }

  /* One <dialog> lightbox per page; arrows step through a booking step's photos. */
  var box, boxImg, boxCount, list = [], idx = 0;
  function show(i) {
    idx = (i + list.length) % list.length;
    boxImg.src = list[idx];
    boxCount.textContent = list.length > 1 ? (idx + 1) + ' of ' + list.length : '';
  }
  function openLightbox(btn) {
    if (!box) {
      box = document.createElement('dialog');
      box.className = 'bsb-lightbox';
      box.setAttribute('aria-label', 'Photo of your bags');
      box.innerHTML = '<img alt="Photo of your bags taken by your BagSafe agent"><div class="bsb-lightbox__bar"><button type="button" data-prev aria-label="Previous photo">‹</button><span data-count></span><button type="button" data-next aria-label="Next photo">›</button><button type="button" data-close>Close</button></div>';
      document.body.appendChild(box);
      boxImg = box.querySelector('img'); boxCount = box.querySelector('[data-count]');
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.closest('[data-close]')) box.close();
        else if (e.target.closest('[data-prev]')) show(idx - 1);
        else if (e.target.closest('[data-next]')) show(idx + 1);
      });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }
    var group = btn.getAttribute('data-bsb-group');
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-bsb-group="' + group + '"]'));
    list = all.map(function (el) { return el.getAttribute('data-bsb-photo'); });
    var multi = list.length > 1;
    box.querySelector('[data-prev]').hidden = !multi;
    box.querySelector('[data-next]').hidden = !multi;
    show(all.indexOf(btn));
    if (box.showModal) box.showModal(); else window.open(list[idx], '_blank', 'noopener');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bsb-photo]');
    if (t) { e.preventDefault(); openLightbox(t); }
  });

  window.BSBook = { place: place, api: api, render: render, renderCourier: renderCourier, skeleton: skeleton, fmt: fmt, fmtDay: fmtDay, esc: esc, initials: initials, icons: ICON, copy: copyText };
})();
